import React from 'react';

export default function SanMiguel() {
  return (
    <>
        <p>
        San Miguel Arcángel, <br/> defiéndenos en la batalla. <br/> Sé nuestro amparo contra las perversidad y asechanzas del demonio. <br/> Reprímale Dios, pedimos suplicantes, <br/> y tu príncipe de la milicia celestial <br/> arroja al infierno con el divino poder <br/> a Satanás y a los otros espíritus malignos <br/> que andan dispersos por el mundo <br/> para la perdición de las almas. <br/> <br/> Amén.
        </p>
    </>
  );
}
